import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';

/* ✅ Profile Card container matching Profile Tab */
export const ProfileCard = styled(Box)(({ theme }) => ({
  height: '100%',
  padding: '16px',
  display: 'flex',
  borderRadius: '16px',
  flexDirection: 'column',
  backgroundColor: '#fff',
  border: '1px solid #d4d8e8',
  boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)',
}));

export const InComplianceGrid = styled(Grid)`
  margin-bottom: 0;
`;

export const GridRightAction = styled(Grid)`
  display: flex;
  justify-content: flex-end;
`;

export const LiveInfoWrapper = styled(MDBox)`
  gap: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
`;

export const DataGridWrapper = styled(MDBox)`
  flex-grow: 1;
  min-height: 300px;
`;
